import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetTermOfServices({ commit }, option) {
  try {
    ApiService.init();
    commit("TERMOFSERVICE_REQUEST");
    ApiService.setHeader();
    const _total = await ApiService.query("/termofservicemanagement");
    const _response = await ApiService.query(
      "/termofservicemanagement",
      option
    );
    commit("TERMOFSERVICE_SUCCESS", {
      results: {
        data: _response.data,
        totalPage: Math.ceil(_total.data.length / option.params._limit)
      }
    });
  } catch (error) {
    commit("TERMOFSERVICE_ERROR", { result: error.message });
  }
}

export async function CreateTermOfService({ commit }, form) {
  try {
    ApiService.init();
    commit("CREATE_TERMOFSERVICE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/termofservicemanagement", form);
    commit("CREATE_TERMOFSERVICE_SUCCESS", { results: _response });
    router.push("/termofservice");
  } catch (error) {
    commit("CREATE_TERMOFSERVICE_ERROR", { result: error.message });
  }
}

export async function GetTermOfService({ commit }) {
  try {
    ApiService.init();
    commit("GET_TERMOFSERVICE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/termofservicemanagement");
    commit("GET_TERMOFSERVICE_SUCCESS", { results: _response });
  } catch (error) {
    commit("GET_TERMOFSERVICE_ERROR", { result: error.message });
  }
}

export async function UpdateTermOfService({ commit }, form) {
  try {
    ApiService.init();
    commit("EDIT_TERMOFSERVICE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/termofservicemanagement/", form);
    commit("EDIT_TERMOFSERVICE_SUCCESS", { results: _response });
    Message({
      message: "Update completed",
      type: "success"
    });
    router.push("/termofservice");
  } catch (error) {
    commit("EDIT_TERMOFSERVICE_ERROR", { result: error.message });
  }
}

export async function DeleteTermOfService({ commit }, id) {
  try {
    ApiService.init();
    commit("DELETE_TERMOFSERVICE_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/termofservicemanagement/" + id);
    commit("DELETE_TERMOFSERVICE_SUCCESS", { id: id });
  } catch (error) {
    commit("DELETE_TERMOFSERVICE_ERROR", { result: error.message });
  }
}
